import { right } from '@popperjs/core';
export var formTitle = {
  marginTop: '1.5em',
  marginBottom: '1em'
};
export var tableWrap = {
  marginBottom: '2.5em'
};
export var tableWrapTabs = {
  marginBottom: '2.5em',
  '& > div': {
    margin: 0
  }
};
export var tableTabsButtonsWrap = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  'div[role=button]': {
    marginBottom: '1em'
  }
};
export var horizontalMargin = {
  margin: '0 2em'
};
export var twoButtonsWrap = {
  'div[role=button]:first-of-type': {
    marginRight: '0.5em'
  }
};
export var headerLeftId = {
  fontSize: '2rem',
  fontWeight: 600,
  display: 'flex',
  alignItems: 'center'
};
export var smallRedText = function smallRedText(theme) {
  return {
    color: theme.error
  };
};
export var headerLeftTitle = function headerLeftTitle(theme) {
  return {
    color: theme.gray300,
    margin: 0,
    textTransform: 'uppercase'
  };
};
export var noRecords = function noRecords(theme) {
  return {
    backgroundColor: theme.gray200,
    padding: '2em 2em',
    textTransform: 'uppercase',
    color: theme.gray500,
    textAlign: 'center'
  };
};
export var headerLeftSubTitle = function headerLeftSubTitle(theme) {
  return {
    color: theme.gray500,
    margin: 0,
    textTransform: 'uppercase'
  };
};
export var headerRightTitle = function headerRightTitle(theme) {
  return {
    color: theme.gray300,
    margin: 0,
    textTransform: 'uppercase',
    '& > span': {
      color: theme.black
    }
  };
};
export var list = function list(theme) {
  return {
    '& .list-group': {
      border: "1px solid ".concat(theme.gray100),
      margin: '2em 0',
      '&.black-border': {
        border: "1px solid ".concat(theme.black)
      },
      '&.all-margin': {
        margin: '2em'
      },
      '&.bold-text p': {
        fontWeight: 600
      }
    },
    '& .list-header': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '1.2em 0.8em',
      borderBottom: "1px solid ".concat(theme.gray100)
    },
    '& .list-title': {
      padding: '1.2em 0.8em',
      borderBottom: "1px solid ".concat(theme.gray100),
      fontSize: '1.4rem',
      '&.black-border': {
        borderBottom: "1px solid ".concat(theme.black)
      }
    },
    '& .no-border': {
      border: 0
    },
    '& .no-padding': {
      padding: 0
    },
    '& .list-Form': {
      padding: '1.2em 0.8em',
      backgroundColor: theme.gray50
    },
    '& .list-Item': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '1.2em 0.8em',
      '& .multi-price-wrap': {
        textAlign: right
      },
      '& .value-info-wrap': {
        display: 'flex',
        alignItems: 'center',
        '& > div:first-of-type': {
          marginRight: '0.5em'
        }
      },
      '&.new-line': {
        flexDirection: 'column',
        alignItems: 'flex-start',
        '& p': {
          marginBottom: '0.4em'
        }
      },
      '& p': {
        color: theme.gray400,
        marginRight: '1em',
        '&.uppercase': {
          textTransform: 'uppercase'
        },
        '&.value': {
          color: theme.black,
          marginRight: 0
        }
      }
    },
    '& .list-Item:nth-of-type(odd)': {
      backgroundColor: theme.gray50
    },
    '& .responsive-table': {
      overflowX: 'auto'
    },
    '& .list-table': {
      width: '100%',
      borderCollapse: 'collapse',
      '& td, th': {
        border: "1px solid ".concat(theme.gray100),
        padding: '0.3em 0.5em',
        '& .table-date': {
          display: 'block',
          width: 90
        }
      },
      '& tr:nth-of-type(even)': {
        backgroundColor: theme.gray50
      }
    }
  };
};
export var imageHolder = function imageHolder(bgimage) {
  return function (theme) {
    return {
      backgroundColor: theme.gray300,
      width: '100%',
      paddingTop: '56.25%',
      position: 'relative',
      backgroundImage: "url(".concat(bgimage, ")"),
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      borderRadius: 0,
      border: "5px solid ".concat(theme.gray100),
      cursor: 'pointer',
      '&:hover': {
        border: "5px solid ".concat(theme.primary)
      }
    };
  };
};
export var imageHolderWrap = function imageHolderWrap(theme) {
  return {
    backgroundColor: theme.gray50,
    borderRadius: 0,
    textAlign: 'center',
    '& > p': {
      fontSize: 12,
      padding: '0.6em 1em 0.4em 1em'
    }
  };
};